import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import TextButton from 'LuxKit/Button/TextButton'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import ContentfulCard from './ContentfulCard'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'

const CarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function ContentfulCardCarousel({ title, cardItems, viewAllLink, isLargeContentWrapper, subtitle }: Omit<App.ContentfulWebPageCardCarousel, 'contentTypeId'>) {
  const intl = useIntl()
  const CardItems = cardItems.map((props, idx) => <div key={`${props.title}-${idx}`}><ContentfulCard {...props} /></div>)

  const viewAllText = intl.formatMessage({
    id: 'Nw9ZhB3yhi6OE1o0_-zR',
    defaultMessage: 'View all',
    description: 'Action button label to view all cards in carousel on the marketing page',
  })
  const readMoreText = intl.formatMessage({
    id: 'aojlE8yRuzzoGDlf-s12',
    defaultMessage: 'Read more',
    description: 'Action button label to expand large content on the marketing page',
  })
  const readLessText = intl.formatMessage({
    id: 'Yg--hM2SfkuKY49old-w',
    defaultMessage: 'Read less',
    description: 'Action button label to collapse large content on the marketing page',
  })

  return (
    <CarouselContainer>
      <VerticalSpacer gap={32}>
        <Group direction="horizontal" horizontalAlign="space-between">
          <Heading variant="heading2" dangerouslySetInnerHTML={{ __html: title }}></Heading>
          {viewAllLink && <TextButton href={viewAllLink} kind="tertiary" size="medium" shape="square">{viewAllText}</TextButton>}
        </Group>
        <VerticalSpacer gap={2}>
          {subtitle && <BodyText variant="large">{subtitle}</BodyText>}
          {isLargeContentWrapper && <LargeContentToggle maxHeight={350} showMoreText={readMoreText} showLessText={readLessText}>
            <CSSBreakpoint min="desktop">
              <CardCarousel pageSize={3}>
                {CardItems}
              </CardCarousel>
            </CSSBreakpoint>
            <CSSBreakpoint max="tablet">
              <CardCarousel pageSize={6}>
                {CardItems}
              </CardCarousel>
            </CSSBreakpoint>
          </LargeContentToggle>}
          {!isLargeContentWrapper && <>
            <CSSBreakpoint min="desktop">
              <CardCarousel pageSize={3}>
                {CardItems}
              </CardCarousel>
            </CSSBreakpoint>
            <CSSBreakpoint max="tablet">
              <CardCarousel pageSize={6}>
                {CardItems}
              </CardCarousel>
            </CSSBreakpoint>
          </>}
        </VerticalSpacer>
      </VerticalSpacer>
    </CarouselContainer>
  )
}

export default ContentfulCardCarousel
